import {environment} from '../environments/environment';

export class Api {
    public getUrl(uri: string, apiVersion: string = environment.Api.version) {
      return environment.Api.url + apiVersion + '/' + uri;
    }
}



// WEBPACK FOOTER //
// ./src/app/utils.ts